module.exports = __webpack_public_path__ + "img/content1.13b3c47f.png";